<template>

  <div style="width: 100%;">

      <!--商品列表-->
      <div class="order-list-goods">
        <div class="order-list-goods-each" v-if="goods">
          <div class="order-list-goods-left">
            <van-image :src="goods.imgUrl" fit="cover">
              <template v-slot:error></template>
            </van-image>
          </div>
          <div class="order-list-goods-right">
            <div class="order-list-goods-name">
              {{goods.productName}}
            </div>
            <div class="order-list-goods-div-bottom">
              分享你的使用体验吧
            </div>
          </div>
        </div>
      </div>

      <loading v-show="showLoading"></loading>

      <!--商品标签-->
      <div class="goods-tags">
        <button v-for="(tag,index) in tagList" :key="index" v-bind:class="[tag.selected == true?'goods-tags-choice':'goods-tags-noChoice']" @click="choiceTag(tag.attributesId)">
          {{tag.name}}
        </button>
      </div>

      <!--商品评论文本-->
      <div class="goods-eval-text">
        <textarea v-model="productReview" placeholder="分享购买心得" maxlength="200" @keyup="getNum()"></textarea>
      </div>

      <!--图片div-->

      <div class="goods-eval-photo">
        <van-uploader v-model="fileList" multiple :max-count="3" :after-read="afterRead"/>
      </div>

      <!--是否匿名-->
      <div class="goods-eval-anonymous">
        <div @click="changeAnonymity()">
          <img src="@/images/icon_Selected@3x.png" v-show="isAnonymity==1">
          <img src="@/images/icon_Unselected@3x.png" v-show="isAnonymity==0">
        </div>
        <div>
          是否匿名
        </div>
      </div>

      <!--发表评价-->
      <div class="order-eval-button" @click="addComment">
        <button>发表评论</button>
      </div>

    </div>

</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getProductEvaluateLabel,uploadFile,addComment} from '@/router/api'
  import { NavBar,Grid, Tabbar, Toast,ActionSheet,Uploader} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import {setStore,getStore} from "../../../utils/mUtil";

  export default {
    name: "orderEvaluation",
    data(){
      return{
        productReview:'',
        showLoading:false,
        token:getStore('externalLoginKey'),
        productId:this.$route.query.productId,
        orderId:this.$route.query.orderId,
        prodCatalogId:prodCatalogId,
        tagList:[],
        orderItemSeqId:this.$route.query.orderItemSeqId,
        productStoreId:storeName,
        goods:{},
        isAnonymity:1,
        images:'',
        fileList: [],
        fileName:'',
        tagValue:''
      }
    },

    mounted(){
      this.initData()
      document.documentElement.scrollTop = 0
    },
    components:{
      [NavBar.name]: NavBar,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      loading,
      [ActionSheet.name]: ActionSheet,
      [Uploader.name]:Uploader,
    },
    methods:{

      afterRead:function(file){
        var canvas =  document.createElement('canvas')
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        var context = canvas.getContext('2d')
        // 创建新的图片对象
        var img = new Image()

        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content
        img.onload = () => {
          if(file.content.length>10000){
            // 指定canvas画布大小，该大小为最后生成图片的大小
            canvas.width = img.width/3
            canvas.height = img.height/3
            /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。*/
            /* 如果不指定缩小的像素，图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后得到的图片就是张局部图。图片小于画布就会有黑边。*/
            context.drawImage(img, 0, 0, img.width/3, img.height/3)
          }else{
            // 指定canvas画布大小，该大小为最后生成图片的大小
            canvas.width = img.width
            canvas.height = img.height
            /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。*/
            /* 如果不指定缩小的像素，图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后得到的图片就是张局部图。图片小于画布就会有黑边。*/
            context.drawImage(img, 0, 0, img.width, img.height)
          }
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.4)
          // 最后将base64编码的图片保存到数组中，留待上传。
        }

      },

      upload:function (file) {
        this.images = ''
        var param = {
          files:file,
          formType:'comment',
          externalLoginKey:this.token
        }
        uploadFile(param)
          .then(res => {
            console.log(res);
            if(res.pathList.length >0){
              for(var i = 0;i<res.pathList.length;i++){
                this.images += res.pathList[i]+','
              }
            }else{
              this.images = ''
            }
            this.uploadComment()
          })
          .catch(err => {
            console.log(err);
          });
      },

      async initData() {
        this.getProductEvaluateLabel();
        this.goods = JSON.parse(getStore('goods'))
      },

      //获取标签列表
      getProductEvaluateLabel:function(){
        var params = {
          productId:this.productId,
          externalLoginKey:this.token,
          prodCatalogId:this.prodCatalogId
        }
        getProductEvaluateLabel(params)
          .then(res => {
            console.log(res);
            this.tagList = res.productList
            for(var i = 0;i<this.tagList.length;i++){
              this.tagList[i].selected = false
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      //获取数据
      getDate:function(){
        this.fileName = ''
        if(this.productReview){
          var tagList = ''
          if(this.tagList.length>0){
            for(var i = 0;i<this.tagList.length;i++){
              if(this.tagList[i].selected == true){
                tagList += this.tagList[i].attributesId + ','
              }
            }
          }else{
            tagList = ''
          }
          this.tagValue = tagList.substring(0,tagList.length-1)

          if(this.fileList.length==0){
            this.showLoading = false;
            this.images = ''
            this.uploadComment()
          }else{
            for(var i = 0;i<this.fileList.length;i++){
              this.fileName += this.fileList[i].file.name+","+this.fileList[i].content.substring(this.fileList[i].content.indexOf(',')+1,this.fileList[i].content.length) + ','
            }

            var name = this.fileName.substring(0,this.fileName.length -1)

            this.upload(name)
          }
        }else{
          this.showLoading = false;
          Toast('请输入评价内容')
        }

      },

      //添加评论
      addComment:function(){
        this.showLoading = true
        this.getDate()
      },

      //用户上传评价
      uploadComment:function(){
        var params = {
          externalLoginKey:this.token,
          productStoreId:this.productStoreId,
          productId:this.productId,
          productReview:this.productReview,
          orderId:this.orderId,
          orderItemSeqId:this.orderItemSeqId,
          tagIdList:this.tagValue,
          isAnonymity:1,
          images:this.images.substring(0,this.images.length-1)
        }
        addComment(params)
          .then(res => {
            console.log(res);
            this.showLoading = false;
            if(res._EVENT_MESSAGE_){
              this.$router.back(-1)
              Toast({message:'发表成功'})
              // this.$router.push({name:'goodsDetail',query:{goodsId:this.productId}})
            }else{
              Toast(res._ERROR_MESSAGE_)
            }
          })
          .catch(err => {
            Toast({message:res._ERROR_MESSAGE_})
            console.log(err);
            this.showLoading = false;
          });
      },

      //用户选择商品标签
      choiceTag:function(attributesId){
        for(var i = 0;i<this.tagList.length;i++){
          if(attributesId == this.tagList[i].attributesId){
            if(this.tagList[i].selected == true){
              this.tagList[i].selected = false
            }else{
              this.tagList[i].selected  = true
            }
          }
        }
        this.$forceUpdate();
      },

      //修改是否匿名
      changeAnonymity:function(){
        if(this.isAnonymity == 1){
          this.isAnonymity = 0
        }else{
          this.isAnonymity = 1
        }
      },

      //判断评价数量
      getNum:function () {
        if(this.productReview.length>200){
          Toast({message:'评价不可超过200字'})
        }
      }
    }


  }
</script>

<style scoped>
  .order-list-goods{
    width:100%;
  }
  .order-list-goods-each{
    width:100%;
    padding-bottom: 0.9375rem;
    padding-top: 0.9375rem;
  }
  .order-list-goods-left{
    display: inline-block;
    vertical-align: top;
    height: 5rem;
    margin-left: 1rem;
    margin-right:0.6875rem;
  }
  .order-list-goods-left .van-image{
    width:5rem;
    height: 5rem;
  }
  .order-list-goods-right{
    width:calc(100% - 8rem);
    display: inline-block;
    vertical-align: top;
  }
  .order-list-goods-name{
    font-size: 0.875rem;
    color:#333;
    line-height: 1.25rem;
    margin-bottom: 1.5rem;
  }
  .order-list-goods-div-bottom{
    width:100%;
    font-size: 0.71875rem;
    color:#999999;
  }
  .goods-tags{
    width:21.4375rem;
    margin: 0 auto;
  }
  .goods-tags button{
    display: inline-block;
    vertical-align: top;
    height:1.40625rem;
    line-height: 1.40625rem;
    font-size: 0.71875rem;
    padding: 0 0.5rem;
    border-radius: 0.703125rem;
    margin-right: 0.625rem;
    margin-top: 1rem;
  }
  .goods-tags-choice{
    background-color: #FFB9C6;
    color:white;
  }
  .goods-tags-noChoice{
    border: 1px solid #666666;
    color:#666666;
  }
  .goods-eval-text{
    width:21.4375rem;
    margin: 1rem auto 1.1875rem;
    height: 10.34375rem;
  }
  .goods-eval-text textarea{
    height: 8.34375rem;
    background-color: #F8F8F8;
    border: 0px;
    border-radius: 0.5rem;
    color:#999999;
    font-size: 0.78125rem;
    padding: 1rem;
  }
  .goods-eval-photo{
    width:21.4375rem;
    margin: 0 auto 0.625rem;
  }
  .goods-eval-photo-each{
    width:5rem;
    height: 5rem;
    margin-right: 0.5rem;
    display: inline-block;
    vertical-align: top;
    margin-bottom: 0.5rem;
  }
  .goods-eval-photo-each .van-image{
    width:100%;
    height: 100%;
  }
  .goods-eval-delete{
    width:1.125rem;
    height: 1.125rem;
    position: relative;
    top: -5.5rem;
    left: 4rem;
  }
  .goods-eval-photo-default{
    width:5rem;
    height: 5rem;
    display: inline-block;
    vertical-align: top;
    background-color: #F5F5F5;
  }
  .goods-eval-photo-default img{
    width:1.21875rem;
    height:1.1875rem;
    margin-top: 1.875rem;
    margin-left: 1.875rem;
  }
  .goods-eval-anonymous{
    width:21.4375rem;
    margin: 0 auto 4rem;
  }
  .goods-eval-anonymous div{
    display: inline-block;
    vertical-align: top;
    color:#666;
    font-size: 0.75rem;
  }
  .goods-eval-anonymous div img{
    width:0.9375rem;
    height: 0.9375rem;
  }

  .order-eval-button{
    width:100%;
    height:4.75rem;
    position: fixed;
    background-color: white;
    bottom: 0;
  }
  .order-eval-button button{
    width:19.375rem;
    height:2.75rem;
    line-height: 2.75rem;
    background-color: #EB84AB;
    text-align: center;
    color:white;
    font-size: 1rem;
    border-radius: 1.375rem;
    position: fixed;
    bottom: 0.9375rem;
    left: 1.9375rem;
  }
  .order-eval-anonymous{
    color:#666666;
    font-size: 0.78125rem;
  }



</style>



// WEBPACK FOOTER //
// src/components/page/mine/orderEvaluation.vue